import React from 'react';
import { Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';

export default function AuthRequiredView({ error }) {
  return (
    <div className="traffix-auth-required">
      <Result
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        status="403"
        title={<span style={{ color: '#fff' }}>Accesso Negato</span>}
        subTitle={
          <span style={{ color: '#a0a0a0' }}>
            {error || 'Token di autenticazione mancante o non valido. Effettua il login per accedere.'}
          </span>
        }
      />
    </div>
  );
}
